import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "features/constants";

const initialState = {
	isLoading: false,
	list: null,
};

export const cfdiUsoRegime = createSlice({
	name: "cfdiUsoRegime",
	initialState,
	reducers: {
		requestCfdiUsoRegimeList: (state) => {
			state.isLoading = true;
		},
		receiveCfdiUsoRegimeList: (state, action) => {
			state.list = action.payload.list;
			state.isLoading = false;
		},
	},
});

export const { requestCfdiUsoRegimeList, receiveCfdiUsoRegimeList } =
	cfdiUsoRegime.actions;

export const fetchCfdiUsoRegimeList = () => async (dispatch) => {
	const headers = {
		"Content-Type": "application/json",
	};
	const options = {
		headers: headers,
	};
	dispatch(requestCfdiUsoRegimeList());
	const url = BASE_API_URL + "/api/Cfdi/UsosRegimenesFiscales";
	await axios
		.get(url, options)
		.then((response) => {
			dispatch(receiveCfdiUsoRegimeList({ list: response.data }));
		})
		.catch((error) => {
			dispatch(receiveCfdiUsoRegimeList({ list: [] }));
		});
};

export default cfdiUsoRegime.reducer;
